"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CallActivityViewModel = void 0;
const ActivityViewModel_1 = require("./ActivityViewModel");
class CallActivityViewModel extends ActivityViewModel_1.ActivityViewModel {
    constructor(callActivity, processModel) {
        super(callActivity, processModel);
        this.processId = callActivity.calledReference;
        this.startEvent = callActivity.startEventId;
        this.payload = callActivity.payload;
    }
}
exports.CallActivityViewModel = CallActivityViewModel;
//# sourceMappingURL=CallActivityViewModel.js.map